import { render, staticRenderFns } from "./Printinfo.vue?vue&type=template&id=253fbe25&scoped=true"
import script from "./Printinfo.vue?vue&type=script&lang=js"
export * from "./Printinfo.vue?vue&type=script&lang=js"
import style0 from "./Printinfo.vue?vue&type=style&index=0&id=253fbe25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253fbe25",
  null
  
)

export default component.exports